export default "query organisationTypes{\n    organisationTypes\n}";